import { PortalConnection } from 'vet-bones/utils/portal';

export const redirectToPortalDashboard = (
  { id: prevId, dashboard: prevDashboard }: PortalConnection,
  { id: nextId, dashboard: nextDashboard }: PortalConnection
) => {
  if (prevId !== nextId && prevDashboard && nextDashboard) {
    window.location.assign(
      window.location.href.replace(prevDashboard, nextDashboard)
    );
  }
};
